import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { EMAILS_REQUEST } from '../../../../../utility/SourceAPI'

export const getEmailsRequest = createAsyncThunk('appEmails/getEmailsRequest', async () => {
    const response = await axios.get(EMAILS_REQUEST)
    return {
        data: response.data
    }
})

export const getAllEmailsRequest = createAsyncThunk('appEmails/getAllEmailsRequest', async () => {
    const response = await axios.get(EMAILS_REQUEST.concat('?all=true'))
    return {
        data: response.data
    }
})

export const getEmailRequestName = createAsyncThunk('appEmails/getEmailRequestName', async () => {
    const response = await axios.get(EMAILS_REQUEST.concat('?is_changed_name=true'))
    return {
        data: response.data
    }
})

export const getEmailCodeRequest = createAsyncThunk('appEmails/getEmailCodeRequest', async (id) => {
    const response = await axios.get(EMAILS_REQUEST.concat(`send-code/${id}`))
    return {
        data: response.data
    }
})

export const verifyEmailCodeRequest = createAsyncThunk('appEmails/verifyEmailCodeRequest', async ({ data }) => {
    const response = await axios.post(EMAILS_REQUEST.concat(`verify-code/${data.id}`), data.code)
    return {
        data: response.data
    }
})

export const createEmailRequest = createAsyncThunk('appEmails/createEmailRequest', async (emailRequest, { dispatch }) => {
    const response = await axios.post(EMAILS_REQUEST, emailRequest)
    await dispatch(getEmailsRequest())
    return response.data
})

export const updateEmailRequest = createAsyncThunk('appEmails/updateEmailRequest', async ({ id, emailRequest }, { dispatch }) => {
    const response = await axios.put(EMAILS_REQUEST.concat(`${id}`), emailRequest)
    await dispatch(getEmailsRequest())
    return response.data
})

export const updateEmail = createAsyncThunk('appEmails/updateEmail', async ({ id, emailData }, { dispatch }) => {
    const response = await axios.put(EMAILS_REQUEST.concat(`recovery/${id}`), emailData)
    await dispatch(getEmailsRequest())
    await dispatch(getAllEmailsRequest())
    return response.data
})

export const updateNameEmail = createAsyncThunk('appEmails/updateNameEmail', async (data, { dispatch }) => {
    const response = await axios.put(EMAILS_REQUEST.concat(`change_email_name/${data?.id}`), data)

    await dispatch(getEmailsRequest())
    await dispatch(getAllEmailsRequest())
    return response.data
})

export const authorizeEmailNameChange = createAsyncThunk('appEmails/authorizeEmailNameChange', async (data, { dispatch }) => {
    const response = await axios.put(EMAILS_REQUEST.concat(`authorize_change_name/${data?.id}`), data)
    await dispatch(getEmailRequestName())
    await dispatch(getAllEmailsRequest())
    return response.data
})

export const emailRequestValidation = createAsyncThunk('appEmails/emailRequestValidation', async (data, { dispatch }) => {
    const response = await axios.post(EMAILS_REQUEST.concat(`validation_reject/${data.id}`), data)
    await dispatch(getEmailsRequest())
    return response.data
})

export const emailActivation = createAsyncThunk('appEmails/emailActivation', async (data, { dispatch }) => {
    const response = await axios.post(EMAILS_REQUEST.concat(`active_correction/${data.id}`), data.action)
    await dispatch(getEmailsRequest())
    await dispatch(getAllEmailsRequest())
    return response.data
})

export const emailsSlice = createSlice({
    name: 'appEmails',
    initialState: {
        dataRequests: [],
        allDataRequests: [],
        emailsChangeName: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getEmailsRequest.fulfilled, (state, action) => {
            state.dataRequests = action.payload.data
        })
        builder.addCase(getAllEmailsRequest.fulfilled, (state, action) => {
            state.allDataRequests = action.payload.data
        })
        builder.addCase(getEmailRequestName.fulfilled, (state, action) => {
            state.emailsChangeName = action.payload.data
        })
    }
})

export default emailsSlice.reducer